import { View } from 'native-base'
import { StyleSheet } from 'react-native'

import { HeaderWithPointsAndLogo, NFTsBar } from '~components'
import { RFColors } from '~constants'
import { nfts } from '~mocks'
import { useGetUser } from '~query-hooks'

export const WalletScreen = (_: WalletScreenProps): JSX.Element => {
  const { user, isLoadingUser } = useGetUser()
  const { points } = user || {}

  return (
    <View style={styles.containerStyle}>
      <HeaderWithPointsAndLogo balance={points || '0'} variant="white" isLoading={isLoadingUser} />
      <NFTsBar nftsList={nfts || []} />
    </View>
  )
}

const styles = StyleSheet.create({
  containerStyle: {
    backgroundColor: RFColors.background,
    flex: 1,
    flexGrow: 1,
  },
})
